import React from 'react';
import { Text, Flex, Stack } from '@chakra-ui/react';
import { UilAngleDown, UilAngleUp } from '@iconscout/react-unicons';
export const getSubmenuValues = ({ propValue }) => {
	return propValue;
};

const EditorSubmenu = ({ title, children }) => {
	const [isOpen, setIsOpen] = React.useState(false);
	const [elementHeight, setElementHeight] = React.useState('0px');
	const elementRef = React.useRef(null);
	const toggleOpen = () => {
		let h = '0px';
		if (!isOpen) {
			h = `${elementRef?.current?.scrollHeight}px`;
		}
		setElementHeight(h);
		setIsOpen(!isOpen);
	};
	return (
		<Flex _hover={{ cursor: 'pointer' }} flex={'1 1 49%'} maxW={'49%'} className="mz-hef-edit" flexDir="column">
			<Flex onClick={() => toggleOpen()}>
				<Text fontWeight={'bold'} fontSize={'sm'}>
					{title}
				</Text>
				{isOpen ? <UilAngleUp size={24} /> : <UilAngleDown size={24} />}
			</Flex>
			<Flex
				className="mz-hef-submenu"
				pl={1}
				overflow={'hidden'}
				transition={'0.4s'}
				ref={elementRef}
				h={elementHeight}
			>
				<Stack w={'100%'} spacing={2}>
					{children}
				</Stack>
			</Flex>
		</Flex>
	);
};

export default EditorSubmenu;
